import type { NotificationListQuery, NotificationListResponse } from './notificationTypes';
import { get, post } from '@/api/request';

export async function fetchNotificationsApi(query: NotificationListQuery = {}) {
  const result = await get<NotificationListResponse>('/api/notifications/', query);
  return result.data;
}

export async function fetchNotificationUnreadCountApi() {
  const result = await get<{ count: number }>('/api/notifications/unread-count/');
  return result.data.count;
}

export async function markNotificationReadApi(id: number | string) {
  await post(`/api/notifications/${id}/read/`);
}

export async function markAllNotificationsReadApi() {
  await post('/api/notifications/read-all/');
}

export async function archiveNotificationApi(id: number | string) {
  await post(`/api/notifications/${id}/archive/`);
}

export async function archiveReadNotificationsApi() {
  await post('/api/notifications/archive-read/');
}
